module.exports = __webpack_public_path__ + "img/sobre.fc55159d.jpg";